import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/i18n/I18nContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Vision from "@/components/Vision";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <div className="App relative grain" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Vision />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.9)",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#f5f5f5",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </I18nProvider>
  );
}

export default App;
